import { useMutation } from '@tanstack/react-query';

import { useGetCurrentBoardId, useGetCurrentOrganisationId } from 'hooks';

import { postForm } from '../requests';
import type { PostBoardFormsRequestType } from '../types';

export const usePostForm = () => {
  const organisationId = useGetCurrentOrganisationId();
  const boardId = useGetCurrentBoardId();

  const pathParams: PostBoardFormsRequestType['pathParams'] = {
    organisationV2: organisationId,
    organisationBoardV2: boardId!,
  };

  return useMutation({
    mutationFn: (bodyParams: PostBoardFormsRequestType['bodyParams']) =>
      postForm({
        pathParams,
        bodyParams,
      }),
  });
};
